export interface CompanyOption {
  name?: string;
  label?: string;
  aliases?: string[];
}

export const companyNames = (option: CompanyOption): string[] =>
  [option.name || option.label || '', ...(option.aliases || [])];

export const matchesCompanyName = (option: CompanyOption, input: string): boolean =>
  companyNames(option).some((name) => name.trim().toLowerCase() === input.trim().toLowerCase());
